/**
 * Addon analytics event listener
 * Listens for custom DOM events from upsell-add-on components
 * and forwards them to GA4 via gtag().
 */

(function () {
  'use strict';

  function sendToGA4(event) {
    if (typeof gtag !== 'function') return;
    var eventName = event.type.replace(':', '_');
    gtag('event', eventName, event.detail || {});
  }

  document.addEventListener('addon:click', sendToGA4);
  document.addEventListener('addon:quick_add', sendToGA4);
  document.addEventListener('addon:modal_atc', sendToGA4);
  document.addEventListener('addon:checkbox_toggle', sendToGA4);
})();
